import { Keyboard } from '@capacitor/keyboard';
import { useEffect } from 'react';

/**
 * Attach Enter key listener to a single IonInput.
 * When Enter is pressed, the input blurs and the keyboard hides (on mobile).
 */
export function useHideKeyboardOnEnter(inputRef: React.RefObject<HTMLIonInputElement>) {
  useEffect(() => {
    let nativeInput: HTMLInputElement | undefined;

    const attach = async () => {
      if (!inputRef.current) return;

      nativeInput = await inputRef.current.getInputElement();
      if (!nativeInput) return;

      const handler = async (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
          nativeInput?.blur();
          await Keyboard.hide();
        }
      };

      nativeInput.addEventListener('keydown', handler);

      return () => {
        nativeInput?.removeEventListener('keydown', handler);
      };
    };

    let cleanup: (() => void) | undefined;

    attach().then((c) => {
      cleanup = c;
    });

    return () => {
      cleanup?.();
    };
  }, [inputRef]);
}
